import { render, staticRenderFns } from "./LoginInputs.vue?vue&type=template&id=585682fd&"
import script from "./LoginInputs.vue?vue&type=script&lang=ts&"
export * from "./LoginInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports